import { Component, HostListener, OnInit, HostBinding, AfterContentInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, NEVER, Observable, zip, BehaviorSubject } from 'rxjs';
import { RouterFacadeService, ViewLabel } from '@services/router-facade.service'
import { NgbAccordionConfig, NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { UserModel, ResellerModel, BusinessModel, LocationModel, NotificationModel } from '@models/index';
import { Role } from "@enums/role.enum";
import { NgxPermissionsService } from 'ngx-permissions';
import { BusinessFacadeService } from '@services/business/business-facade.service'
import { AppFacadeService } from '@services/app-facade.service';
import { AuthFacadeService } from '@services/auth/auth-facade.service';
import { ResellersFacadeService } from '@services/resellers/resellers-facade.service';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { skip, filter, distinctUntilChanged, map, debounceTime, combineLatestWith } from 'rxjs/operators';
import { notificationType } from '@enums/notificationType.enum';
import { emptyResellerModel } from '@utilities/data-utils';
import { ReviewTargetsFacadeService } from '@services/review-targets/review-targets-facade.service';
import Swal from 'sweetalert2';
import { FilterService, MessageService } from 'primeng/api';

declare var dataLayer: any; // Google Tag Manager
import { remainingTrialDays } from '@utilities/function-utils';
import { LocationBusinessMetadata } from '@actions/auth/auth.actions';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.sass'],
  providers: [NgbAccordionConfig]
})
export class NavigationComponent implements OnInit, AfterContentInit {
  _subs: Subscription = NEVER.subscribe();

  currentViewTitle$: Observable<string> = this.routerFacadeService.routerLabel$.pipe(
    map((vl: ViewLabel) => typeof vl == 'string' ? vl : vl.title),
  )
  currentViewSubtitle$: Observable<string | null> = this.routerFacadeService.routerLabel$.pipe(
    map((vl: ViewLabel) => typeof vl == 'string' ? null : vl.subtitle),
  )
  currentViewStatusIndicator$: Observable<string> = this.routerFacadeService.routerLabel$.pipe(
    map((vl: ViewLabel) => typeof vl == 'string' ? null : vl.statusIndicator),
  )

  @Input() showingShelf: boolean = false;
  @Input() largeShelf: boolean = false;
  permissions: any;

  newInnerWidth: number;
  activeId: string[] = [];
  showSideBar: boolean = true;
  @HostBinding('class.isActive')
  get isActiveAsGetter() {
    return this.isActive;
  }
  isActive: boolean;
  businesses$ = this.businessesFacadeService.getBusinesses$();
  selectedBusiness$ = this.businessesFacadeService.getSelectedBusiness$()
  openSideDrawer$ = this.appFacadeService.openSideDrawer$()
  selectedBusiness: boolean;
  selectedBusinessProfile: BusinessModel;
  selectedReseller$ = this.resellerFacadeService.getSelectedReseller$()
  selectedReseller: boolean;
  selectedResellerProfile: ResellerModel = emptyResellerModel();
  selectedLocation$ = this.locationFacadeService.getCurrentLocation$()
  selectedLocation: boolean;
  businessLocations$ = this.locationsFacadeService.getLocationTotal$()
  businessLocations: number;
  businessLocationsAutocomplete$ = this.authFacadeService.getLocationAutocompleteOptions$().pipe(
    map((list) => (list || []).length > 0 ? list : null),
  );
  businessLocationsAutocomplete: { businessName: string, businessId: string, locations: LocationBusinessMetadata[] }[];
  selectedLocationProfile: LocationModel;
  loggedUser$: Observable<UserModel> = this.appFacadeService.getLoggedUser$()
  loggedUser: UserModel = {
    firstName: "",
    lastName: "",
    email: "",
    role: {
      id: '',
      name: Role.None,
      shortName: '',
      labelName: '',
      createdAt: null,
      updatedAt: null,
      deletedAt: null,
      deleted: false,
    },
    permissions: []
  };
  // TODO: some users with the wrong User#role will have the issue
  shouldGroupSearchResults$ = this.loggedUser$.pipe(
    combineLatestWith(this.businesses$),
    map(([loggedUser, businesses]) => false
      || [Role.SiteAdmin, Role.Reseller].includes(loggedUser.role.name)
      || businesses.length > 1
      || loggedUser.businesses?.length > 1
    )
  );
  currentState = 'final'
  initialSelectedReseller: ResellerModel = emptyResellerModel();
  Role = Role;
  lasNotification$: Observable<NotificationModel> = this.appFacadeService.getLastNotification$()
  resellerSwalText = {
    title: 'This reseller has been deleted',
    text: `Please select another resller`,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK'
  }
  locationSwalText = {
    title: 'This location has been deleted',
    text: `Please select another location`,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK'
  }
  businessSwalText = {
    title: 'This business has been deleted',
    text: `Please select another business`,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK'
  }
  showCloseSideBar = false
  repopulateSearchSelection$$ = new BehaviorSubject<boolean>(true);

  reviewTargetWithError$: Observable<boolean> = this.reviewTargetFacadeService.getLocationReviewTargetWithErrors$()

  constructor(
    private routerFacadeService: RouterFacadeService,
    public router: Router,
    private businessesFacadeService: BusinessFacadeService,
    private appFacadeService: AppFacadeService,
    private authFacadeService: AuthFacadeService,
    private resellerFacadeService: ResellersFacadeService,
    private locationFacadeService: LocationsFacadeService,
    private authService: AuthFacadeService,
    private businessFacadeService: BusinessFacadeService,
    private locationsFacadeService: LocationsFacadeService,
    private reviewTargetFacadeService: ReviewTargetsFacadeService,
    private permissionsService: NgxPermissionsService,
    private window: Window,
    private filterService: FilterService,
    private messageToast: MessageService,
  ) {
    // this.getScreenSize()
  }

  ngOnInit() {}

  ngAfterContentInit() {
    this.permissions = this.permissionsService.getPermissions()

    this.newInnerWidth = this.window.innerWidth

    this._subs.add(
      this.selectedBusiness$.subscribe((business) => {
        this.selectedBusiness = business.id ? true : false;
        this.selectedBusinessProfile = business;
        this.businessFacadeService.searchBusinesLocations(this.selectedBusinessProfile.id)

        if (dataLayer) dataLayer.push({
          event: 'user-metadata-updated',
          businessId: business.id,
          businessName: business.id ? business.name : null,
        });
      })
    );

    this._subs.add(
      this.businessLocations$.subscribe(businessLocations =>
        this.businessLocations = businessLocations)
    )

    this._subs.add(
      this.selectedReseller$.subscribe((selectedReseller) => {
        if (selectedReseller.id != this.selectedResellerProfile.id) {
          this.authFacadeService.searchLocationAutocompleteOptions(selectedReseller.id);
        }

        this.selectedReseller = selectedReseller.id ? true : false;
        this.selectedResellerProfile = selectedReseller;

        if (dataLayer) dataLayer.push({
          event: 'user-metadata-updated',
          resellerId: selectedReseller.id,
          resellerName: selectedReseller.id ? selectedReseller.name : null,
        });
      })
    );

    this._subs.add(
      this.selectedLocation$.subscribe((selectedLocation) => {
        this.selectedLocation = selectedLocation.id ? true : false;
        this.selectedLocationProfile = selectedLocation;

        this.locationFacadeService.getContactsLast14Days(selectedLocation.id)
        this.locationFacadeService.getReviewsLast14Days(selectedLocation.id)

        //this.searchQueryText = selectedLocation.name

        if (dataLayer) dataLayer.push({
          event: 'user-metadata-updated',
          locationId: selectedLocation.id,
          locationName: selectedLocation.id ? selectedLocation.name : null,
        })
      })
    );

    this._subs.add(
      this.loggedUser$
        .subscribe((loggedUser) => {
          this.loggedUser = loggedUser

          if (dataLayer) dataLayer.push({
            event: 'user-metadata-updated',
            userFirstName: loggedUser.firstName,
            userLastName: loggedUser.lastName,
            userEmail: loggedUser.email,
          })
        })
    );
    
    this._subs.add(
      this.authService
        .getSelectedReseller$()
        .subscribe(selectedReseller => {
          this.initialSelectedReseller = selectedReseller
          
          document.title = this.initialSelectedReseller.name != '' ? this.initialSelectedReseller.name : 'Loading...'
        })
    );
    this._subs.add(
      this.lasNotification$.pipe(
        skip(1),
        filter(notification => (notification.type === notificationType.resellerDelete)
          || (notification.type === notificationType.resellerUpdate)
          || (notification.type === notificationType.businessDelete)
          || (notification.type === notificationType.businessUpdate)
          || (notification.type === notificationType.locationDelete)
          || (notification.type === notificationType.locationUpdate)
        )
      ).subscribe(notification => {
        if (notification.type === notificationType.resellerDelete && notification.id === this.selectedResellerProfile.id) {
          this.showSwalWindow(this.resellerSwalText, this.resellerRouter)
        } else if (notification.type === notificationType.businessDelete && notification.id === this.selectedBusinessProfile.id) {
          this.showSwalWindow(this.businessSwalText, this.businessRouter)
        } else if (notification.type === notificationType.locationDelete && notification.id === this.selectedLocationProfile.id) {
          this.showSwalWindow(this.locationSwalText, this.locationRouter)
        }
      })
    )
    this._subs.add(
      this.reviewTargetWithError$.pipe(
        distinctUntilChanged()
      ).subscribe(error => {
        console.log("Review target Error ", error);
        
        this.reviewTargetFacadeService.searchReviewTargetsByLocation({ page: 0, size: 100 })
      })
    )

    this._subs.add(
      this.businessLocationsAutocomplete$.subscribe(results => {
        this.businessLocationsAutocomplete = results;
      })
    );

    this._subs.add(
      this.businessLocationsAutocomplete$.pipe(
        combineLatestWith(
          this.selectedLocation$,
          this.repopulateSearchSelection$$.pipe(debounceTime(100), filter(reload => reload == true))
        )
      ).subscribe(([groups, selectedLocation, _]) => {
        if (selectedLocation.id == null) {
          this.selectedMetadata = null;
          return;
        }

        if (groups == null) {
          // still loading metadata, show what we have available
          const { businessId, name, id } = selectedLocation;
          const selected = { businessId, businessName: "", locationId: id, locationName: name };

          this.filteredGroups = [{ label: "", value: "", items: [selected] }];
          this.selectedMetadata = selected;
        } else {
          const group = groups.find(g => g.businessId == selectedLocation.businessId);
          const location = group.locations.filter(l => l.locationId == selectedLocation.id).shift();

          this.selectedMetadata = location;
        }
      })
    );

    this._subs.add(
      zip(
        this.locationFacadeService.getContactsLast14Days$(),
        this.locationFacadeService.getReviewsLast14Days$(),
        this.selectedLocation$
      ).pipe(
        map(([contactCount, reviewCount, selectedLocation]) => ({
          contactCount: contactCount,
          reviewCount: reviewCount,
          locationId: selectedLocation.id,
          locationName: selectedLocation.id ? selectedLocation.name : null,
        }))
      ).subscribe(data => {
        if (dataLayer) {
          console.log(` Location Name : ${data.locationName} Contact Count : ${data.contactCount},  Review Count : ${data.reviewCount}`)
          dataLayer.push(data)
        }
      })
    );
    // this.locationFacadeService.getReviewsLast14Days$().subscribe(data=> console.log(` Review Count : ${data}`))
  }

  onShowSideBar() {
    this.showSideBar = !this.showSideBar
    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
  }

  gotoAuth() {
    this.authFacadeService.logOut();
    this.routerFacadeService.gotoAuth$()
  }

  @ViewChild('sidebar') appSidebar: ElementRef;

  navigateTo(pathUrl: string, params: { [key: string]: string } = {}): true {
    this.routerFacadeService.navigateTo$(pathUrl, params)

    if (params.next) {
      this.messageToast.add({ severity: 'error', summary: 'No Location Selected', detail: 'You need to select a location to view this page.' });
    }

    // close sidebar on navigation if it's positionally fixed (i.e. above page content)
    const sidebarStyle = this.window.getComputedStyle(this.appSidebar.nativeElement);
    if (sidebarStyle.getPropertyValue('position') == 'fixed') {
      this.showSideBar = false
      this.currentState = 'initial'
    }
    return true
  }

  changeUser(user: UserModel) {
    this.authFacadeService.selectUserProfileByRole(user)
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;
    if (this.newInnerWidth < 1200 && this.showSideBar == true) {
      this.showSideBar = false
      this.currentState = 'initial'
    }
  }

  showSwalWindow(data: { title: string, text: string, type, showCancelButton: boolean, confirmButtonText: string }, routerFunction) {
    Swal.fire({
      title: data.title,
      text: data.text,
      icon: data.type,
      showCancelButton: data.showCancelButton,
      confirmButtonText: data.confirmButtonText,
    }).then(routerFunction)
  }

  resellerRouter = (data) => {
    this.routerFacadeService.navigateTo$('admin/reseller')
    this.resellerFacadeService.clearSelectedReseller()
    this.businessFacadeService.clearSelectedBusinessProfile()
    this.locationsFacadeService.clearCurrentLocation()
  }

  businessRouter = () => {
    this.routerFacadeService.navigateTo$('reseller/business')
    this.businessFacadeService.clearSelectedBusinessProfile()
    this.locationsFacadeService.clearCurrentLocation()
  }

  locationRouter = () => {
    this.routerFacadeService.navigateTo$('admin-business/locations')
    this.locationsFacadeService.clearCurrentLocation()
  }
  gotoLocationProfile() {
    this.routerFacadeService.navigateTo$('admin-location/profile')
    this.locationFacadeService.findLocationById(this.selectedLocationProfile.id)
  }

  isAccordionActive(menu: string): boolean {
    switch (menu.toLowerCase()) {
      case 'reports':
        return false
          || this.router.isActive('/admin-business/reports', false)
      case 'reviews':
        return false
          || this.router.isActive('/admin-location/reviews', true)
          || this.router.isActive('/admin-location/location-review-targets', true)
      case 'review-requests':
        return false
          || this.router.isActive('/admin-location/campaigns', false)
          || this.router.isActive('/admin-location/send', false)
          || this.router.isActive('/admin-location/feedback', true)
          || this.router.isActive('/admin-location/profile', true)
      case 'showcasing':
        return false
          || this.router.isActive('/admin-location/widgets', true)
          || this.router.isActive('/admin-location/sharing', true)
      case 'configurations':
        return false
          || this.router.isActive('/admin-business/profile', true)
          || this.router.isActive('/admin-business/locations', true)
          || this.router.isActive('/admin-business/users', true)
      default:
        return false
    }
  }

  @ViewChild('accordion') accordion: NgbAccordionDirective;
  closeInactiveOthers(except: string) {
    console.log('this.accordion:', this.accordion);
    const ids = [
      'reports',
      'reviews',
      'review-requests',
      'showcasing',
      'configurations'
    ]

    ids.filter(id => id != except && !this.isAccordionActive(id)).forEach(id => {
      this.accordion.collapse(id);
    })
  }

  daysTrial() {
    return remainingTrialDays(
      this.window.moment(this.selectedBusinessProfile.trialEndDate).startOf('day').unix(),
      this.window.moment(this.window.moment.now()).startOf('day').unix()
    )
  }

  /*
   * p-autoComplete
   */
  selectedMetadata: LocationBusinessMetadata;
  filteredGroups: ({ label: string, value: string, items: LocationBusinessMetadata[] } | LocationBusinessMetadata)[];

  focusOnBackspaceClear($event: Event, autocomplete: AutoComplete) {
    if (($event.target as HTMLInputElement).value == '') {
      // skip two event loops, then delay 100ms
      //
      // the alternatives failed:
      // - run search and/or show immediately: doesn't work
      // - skip 1 or 2 event loops: doesn't work
      // - 3 event loops (with setTimeout(..., 1)): works 90% of the time
      // - just setTimeout(..., 100): works 90% of the time
      // - ngZone.run(...): doesn't work
      // - ngZone.runOutsideAngular(() => ngZone.run(...)): doesn't work, slow
      //
      // it works™
      setTimeout(() => {
        setTimeout(() => {
          setTimeout(() => {
            autocomplete.search($event, '');
            autocomplete.show();
          }, 100);
        }, 1);
      }, 1);
    }
  }

  filterGroupedCity(event: { originalEvent: Event, query: string }, autocomplete: AutoComplete) {
    let query = event.query;
    console.log('query:', query);
    let filteredGroups = [];

    for (let optgroup of this.businessLocationsAutocomplete) {
      // show results where the business or location name match
      const filteredSubOptions = this.filterService.filter(
        optgroup.locations,
        ['locationName', 'businessName'],
        query,
        "contains"
      );

      if (filteredSubOptions && filteredSubOptions.length) {
        filteredGroups.push({
          label: optgroup.businessName,
          value: optgroup.businessId,
          items: filteredSubOptions.sort((a, b) => {
            // rank results by earliest presence of search query in *locationName*
            return b.locationName.toLowerCase().indexOf(query.toLowerCase())
              - a.locationName.toLowerCase().indexOf(query.toLowerCase())
          }),
        });
      }
    }
    
    console.log('this.businessLocationsAutocomplete:', this.businessLocationsAutocomplete);
    console.log('filteredGroups:', filteredGroups);

    if (filteredGroups.length == 0) {
      // still show currently selected business name if there are no results
      this.filteredGroups = (!!this.selectedBusinessProfile.id
        ? [{
          label: this.selectedBusinessProfile.name,
          value: this.selectedBusinessProfile.id,
          items: []
        }]
        : []
      );
    }

    if (autocomplete.group) {
      if (filteredGroups.length > 0) {
        this.filteredGroups = filteredGroups;
      } else {
      }
    } else {
      this.filteredGroups = (filteredGroups.shift() || {}).items || []
    }
  }

  // group: the group from this.filteredGroups
  onSelectBusiness(event: Event, autocomplete: AutoComplete, group: { value: BusinessModel['id'] }) {
    event.preventDefault();
    this.blurAfterSelection(autocomplete);
    
    if (this.selectedBusinessProfile.id != group.value) {
      this.businessFacadeService.searchBusinessById(group.value);
    }

    setTimeout(() => {
      this.routerFacadeService.navigateTo$('/admin-business/locations');
    }, 800);
  }

  onSelectLocation(value: LocationBusinessMetadata, autocomplete: AutoComplete) {
    this.blurAfterSelection(autocomplete);
    this.locationFacadeService.searchAndNavigateToBusinessLocation(value);
  }

  blurAfterSelection(autocomplete: AutoComplete) {
    Array.from<HTMLElement>(autocomplete.el.nativeElement.getElementsByTagName('input')).forEach(el => {
      setTimeout(() => el.blur(), 1);
    });
    
    // only necessary for onSelectBusiness but works fine in both scenarios
    setTimeout(() => autocomplete.hide(), 1);
  }
}
